// Fixed demo / Play-Store-review account: 1234567890 / 7890.
// Mirrors DEMO_MOBILE in the API (api/new/functions.js). For this number the app
// skips device binding (reviewers use any phone/browser) and never asks for an
// OTP (Meta bills per OTP; the API also refuses to send one for it).
export const DEMO_MOBILE = '1234567890';
export const isDemoMobile = (m) => String(m || '').trim() === DEMO_MOBILE;
